import { render } from "./ColoredText.vue?vue&type=template&id=18bc7b87&scoped=true"
import script from "./ColoredText.vue?vue&type=script&lang=js"
export * from "./ColoredText.vue?vue&type=script&lang=js"

import "./ColoredText.vue?vue&type=style&index=0&id=18bc7b87&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18bc7b87"]])

export default __exports__